import { FC } from 'react';
import { SelfScan } from './SelfScan/SelfScan';

export const SelfScanPage: FC = () => {
  return <SelfScan />;
};
